import HeroMaster from "@/components/HeroMaster";
import Logistics from "@/components/Logistics";
import DigitalTransition from "@/components/DigitalTransition";
import Technology from "@/components/Technology";
import Scale from "@/components/Scale";
import Ecosystem from "@/components/Ecosystem";
import Marquee from "@/components/Marquee";
import Footer from "@/components/Footer";

export default function Home() {
  return (
    <>
      <main>
        <HeroMaster />
        <Logistics />
        <DigitalTransition />
        <Technology />
        <Scale />
        <Ecosystem />
        <Marquee />
      </main>
      <Footer />
    </>
  );
}
